import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { useNavigate } from "react-router";
import { useParams } from "react-router";
import Cookies from "js-cookie";

const PersonalDetail = () => {
  const { baseUrl, selectedStaff, openToast } = useGlobalContext();
  console.log(selectedStaff)
  const [isLoadingPersonalDetails, setIsLoadingPersonalDetails] =
    useState(false);
  const [isLoadingGovernmentIds, setIsLoadingGovernmentIds] = useState(false);
  const [authToken, setAuthToken] = useState(selectedStaff?.staffDetails?.login_otp);

  const [personalDetailsUpdate, setPersonalDetailsUpdate] = useState({
    name: selectedStaff?.name,
    mobile: selectedStaff?.mobile,
    official_email: selectedStaff?.staffDetails?.official_email,
    date_of_birth: selectedStaff?.staffDetails?.date_of_birth,
    gender: selectedStaff?.staffDetails?.gender,
    date_of_joining: selectedStaff?.staffDetails?.date_of_joining,
    marital_status: selectedStaff?.staffDetails?.marital_status,
    guardian_name: selectedStaff?.staffDetails?.guardian_name,
    blood_group: selectedStaff?.staffDetails?.blood_group,
    emergency_contact_name: selectedStaff?.staffDetails?.emergency_contact_name,
    emergency_contact_mobile:
      selectedStaff?.staffDetails?.emergency_contact_mobile,
    emergency_contact_relation:
      selectedStaff?.staffDetails?.emergency_contact_relation,
    emergency_contact_address:
      selectedStaff?.staffDetails?.emergency_contact_address,
    current_address: selectedStaff?.staffDetails?.current_address,
    permanent_address: selectedStaff?.staffDetails?.permanent_address,
  });

  const [governmentIds, setGovernmentIds] = useState({
    voter_id_number:
      selectedStaff?.staffDetails?.staff_bg_verification?.voter_id_number,
    aadhaar_number:
      selectedStaff?.staffDetails?.staff_bg_verification?.aadhaar_number,
    pan_number: selectedStaff?.staffDetails?.staff_bg_verification?.pan_number,
    uan_number: selectedStaff?.staffDetails?.staff_bg_verification?.uan_number,
    driving_license_number:
      selectedStaff?.staffDetails?.staff_bg_verification
        ?.driving_license_number,
  });

  const updatePersonalDetails = async (e) => {
    setIsLoadingPersonalDetails(true);
    e.preventDefault();

    const data = {};

    // Add each field to the data object only if it's not an empty string
    if (personalDetailsUpdate.name) data.name = personalDetailsUpdate.name;
    if (personalDetailsUpdate.mobile)
      data.mobile = personalDetailsUpdate.mobile;
    if (personalDetailsUpdate.official_email)
      data.official_email = personalDetailsUpdate.official_email;
    if (personalDetailsUpdate.date_of_birth)
      data.date_of_birth = new Date(
        personalDetailsUpdate.date_of_birth
      ).toISOString();
    if (personalDetailsUpdate.gender)
      data.gender = personalDetailsUpdate.gender;
    if (personalDetailsUpdate.guardian_name)
      data.guardian_name = personalDetailsUpdate.guardian_name;
    if (personalDetailsUpdate.blood_group)
      data.blood_group = personalDetailsUpdate.blood_group;
    if (personalDetailsUpdate.marital_status)
      data.marital_status = personalDetailsUpdate.marital_status;
    if (personalDetailsUpdate.emergency_contact_name)
      data.emergency_contact_name =
        personalDetailsUpdate.emergency_contact_name;
    if (personalDetailsUpdate.emergency_contact_mobile)
      data.emergency_contact_mobile =
        personalDetailsUpdate.emergency_contact_mobile;
    if (personalDetailsUpdate.emergency_contact_relation)
      data.emergency_contact_relation =
        personalDetailsUpdate.emergency_contact_relation;
    if (personalDetailsUpdate.emergency_contact_address)
      data.emergency_contact_address =
        personalDetailsUpdate.emergency_contact_address;
    if (personalDetailsUpdate.current_address)
      data.current_address = personalDetailsUpdate.current_address;
    if (personalDetailsUpdate.permanent_address)
      data.permanent_address = personalDetailsUpdate.permanent_address;
    if (authToken) data.login_otp = authToken
    try {
      const response = await fetch(baseUrl + "staff/" + selectedStaff?.id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify(data), // send the formatted data
      });
      const result = await response.json();
      console.log(result, "sjfjaosdjoi");
      if (response.status === 200) {
        console.log(result);
        setPersonalDetailsUpdate({
          name: result?.name,
          mobile: result?.mobile,
          official_email: result?.staffDetails?.official_email,
          date_of_birth: result?.staffDetails?.date_of_birth,
          gender: result?.staffDetails?.gender,
          blood_group: result?.staffDetails?.blood_group,
          marital_status: result?.staffDetails?.marital_status,
          guardian_name: result?.staffDetails?.guardian_name,
          emergency_contact_name: result?.staffDetails?.emergency_contact_name,
          emergency_contact_mobile:
            result?.staffDetails?.emergency_contact_mobile,
          emergency_contact_relation:
            result?.staffDetails?.emergency_contact_relation,
          emergency_contact_address:
            result?.staffDetails?.emergency_contact_address,
          current_address: result?.staffDetails?.current_address,
          permanent_address: result?.staffDetails?.permanent_address,
        });

        setAuthToken(result?.login_otp);
        openToast("Personal Details updated Successfully", "success");
      } else {
        openToast(result.message || "error");
      }
    } catch (error) {
      console.error("Error updating personal details:", error);
      openToast("An error occurred while updating personal details", "error");
    } finally {
      setIsLoadingPersonalDetails(false);
      setIsEditable(false);
      setIsEditable7(false);
    }
  };

  console.log(selectedStaff);

  const { id } = useParams();
  // console.log(id)
  const formatDate = (date) => {
    if (!date) return ""; // Return an empty string if no date is provided
    const d = new Date(date);

    // Extract the date components
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    // Pad month and day with leading zeros if needed
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-"); // Format as "YYYY-MM-DD"
  };

  const getData = async (e) => {
    try {
      const response = await fetch(baseUrl + "staff/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        console.log(result)
        console.log(response);
        const filteredData = result.data.find((item) => item.id === selectedStaff.id);
        setPersonalDetailsUpdate({
          name: filteredData.name,
          mobile: filteredData.mobile,
          official_email: filteredData.official_email,
        });
        console.log("Filtered data by ID:", filteredData);

        console.log("Data retrieved successfully:", result);
        // navigate("/admin/staff");
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };

  const [basicDetail, setBasicDetail] = useState({
    name: "", // or a default value
    job_title: "",
    branch: "",
    mobile: "",
    login_otp: "",
    gender: "",
    official_email: "",
    date_of_joining: "",
    date_of_birth: "",
    current_address: "",
    permanent_address: "",
    emergency_contact_name: "",
    emergency_contact_mobile: "",
    emergency_contact_relation: "",
    emergency_contact_address: "",
  });
  useEffect(() => {
    getData();
  }, []);

  const [isEditable, setIsEditable] = useState(false);
  const handleEditClick = (e) => {
    e.preventDefault();
    setIsEditable(true);
    if (isEditable) {
      updatePersonalDetails(e);
    }
  };

  const [inputValue, setInputValue] = useState("--");
  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update the value of input field
  };

  const [isEditable6, setIsEditable6] = useState(false);
  const handleEditClick2 = () => {
    setIsEditable6(true);
    if (isEditable6) {
      updateAllGovernmentIds();
    }
  };

  const [isEditable7, setIsEditable7] = useState(false);
  const handleEditClick3 = (e) => {
    setIsEditable7(true);
    if (isEditable7) {
      updatePersonalDetails(e);
    }
  };


  async function updateAllGovernmentIds() {
    setIsLoadingGovernmentIds(true);
    const idsToUpdate = [
      { idType: "aadhaar", value: governmentIds?.aadhaar_number },
      { idType: "pan", value: governmentIds?.pan_number },
      {
        idType: "driving_license",
        value: governmentIds?.driving_license_number,
      },
      {
        idType: "voter_id",
        value: governmentIds?.voter_id_number,
      },
      { idType: "uan", value: governmentIds?.uan_number },
    ];

    console.log(idsToUpdate);
    try {
      for (const { idType, value } of idsToUpdate) {
        if (value) {
          // Only send the request if the value exists
          const formData = new FormData();
          formData.append(
            idType === "aadhaar" ? "aadhaar_number" : `${idType}_number`,
            value
          );

          const response = await fetch(
            `${baseUrl}bg-verification/${selectedStaff.staffDetails.id}/verify/${idType}`,
            {
              method: "PUT",
              headers: {
                // "Content-Type": "form-data",
                "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
              },
              body: formData,
            }
          );

          if (response.status !== 201) {
            throw new Error(`Failed to update ${idType}`);
          }

          const result = await response.json();
          setGovernmentIds((prev) => ({
            ...prev,
            [`${idType}_number`]: result?.data?.[`${idType}_number`] || value,
            [`${idType}_status`]:
              result?.data?.[`${idType}_verification_status`],
          }));
        }
      }

      // Show success toast if all requests succeed
      openToast("All government IDs successfully updated", "success");
    } catch (error) {
      console.error("Error updating government IDs:", error);
      openToast("An error occurred while updating government IDs", "error");
    } finally {
      setIsEditable6(false);
      setIsLoadingGovernmentIds(false);
    }
  }

  return (
    <>
      <div className='pb-[20px]'>
        <div className="top-0 flex justify-between items-center bg-white p-[30px] pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]">
          <h3 className="bg-[#fff] shadow-cs pt-[10px] pb-[10px] pl-[14px] rounded-md w-full font-medium">Personal Details</h3>
        </div>

        <h2 className="bg-[#fff] pt-[15px] font-medium">
          Basic Details
        </h2>
        <form className="shadow-md m-auto mt-[10px] p-[12px] xl:p-[24px] border border-1 rounded-md w-[100%] xl:w-[100%]">
          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Name</label>
              <br />
              <input
                value={personalDetailsUpdate.name}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    name: e.target.value,
                  })
                }
                type="text"
                defaultValue={selectedStaff?.name}
                placeholder="Enter Name"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Mobile</label>
              <br />
              <input
                value={personalDetailsUpdate.mobile}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    mobile: e.target.value,
                  })
                }
                type="number"
                defaultValue={selectedStaff?.mobile}
                placeholder="Enter Mobile "
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Personal Email ID</label>
              <br />
              <input
                value={personalDetailsUpdate.official_email}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    official_email: e.target.value,
                  })
                }
                type="email"
                defaultValue={selectedStaff?.official_email}
                placeholder="Enter Name"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">DOB</label>
              <br />
              <input
                type="date"
                onClick={(e) => {
                  if (isEditable) {
                    e.target.showPicker();
                  }
                }}
                placeholder="Enter Mobile"
                value={formatDate(personalDetailsUpdate?.date_of_birth)}
                onChange={(e) => {
                  console.log(e.target.value);
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    date_of_birth: e.target.value,
                  });
                }}
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Gender</label>
              <br />
              <select
                value={personalDetailsUpdate.gender}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    gender: e.target.value,
                  })
                }
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              >
                <option value={"Male"}>Male</option>
                <option value={"Female"}>Female</option>
                <option value={"Other"}>Others</option>
              </select>
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Maritial Status</label>
              <br />
              <select
                value={personalDetailsUpdate?.marital_status}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    marital_status: e.target.value,
                  })
                }
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              >
                <option value={"Married"}>Married</option>
                <option value={"Unmarried"}>Unmarried</option>
              </select>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Blood Group</label>
              <br />
              <select
                value={personalDetailsUpdate?.blood_group}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    blood_group: e.target.value,
                  })
                }
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              >
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>

              </select>
            </div>
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Guardian's Name </label>
              <br />
              <input
                value={personalDetailsUpdate?.guardian_name}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    guardian_name: e.target.value,
                  })}
                type="text"
                placeholder="Guardian s Name "
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Emergency Contact Name </label>
              <br />
              <input
                type="text"
                value={personalDetailsUpdate.emergency_contact_name}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    emergency_contact_name: e.target.value,
                  })
                }
                placeholder="Contact Name"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">
                Emergency Contact Mobile Number{" "}
              </label>
              <br />
              <input
                type="number"
                value={personalDetailsUpdate.emergency_contact_mobile}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    emergency_contact_mobile: e.target.value,
                  })
                }
                placeholder="Enter Number"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">
                Emergency Contact Relationship
              </label>
              <br />
              <input
                type="text"
                value={personalDetailsUpdate.emergency_contact_relation}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    emergency_contact_relation: e.target.value,
                  })
                }
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Auth Token</label>
              <br />
              <input
                type="text"
                value={authToken}
                onChange={(e) => setAuthToken(e.target.value)}
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>



          <div className="w-[100%] xl:w-[100%] 2xl:w-[100%]">
            <label className="text-[14px]">Emergency Contact Address</label>
            <br />
            <textarea
              type="text"
              rows="2"
              defaultValue={personalDetailsUpdate.emergency_contact_address}
              onChange={(e) =>
                setPersonalDetailsUpdate({
                  ...personalDetailsUpdate,
                  emergency_contact_address: e.target.value,
                })
              }
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
              style={{
                boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
              }}
            />
          </div>



          <div className="flex justify-end mt-4 p-3">
            <div className="flex items-center gap-[20px]">
              <button
                type="button"
                disabled={isLoadingPersonalDetails}
                className={
                  "second-btn " +
                  (isLoadingPersonalDetails &&
                    "cursor-not-allowed animate-pulse opacity-50")
                }
                onClick={(e) => {
                  handleEditClick(e);
                }}
              >
                {isEditable ? "Save" : "Edit"}
              </button>
            </div>
          </div>
        </form>

        <h2 className="mt-7 pt-[10px] pb-[0px] font-medium">
          Government IDs
        </h2>

        <form className="shadow-md m-auto mt-[10px] p-[12px] xl:p-[24px] border border-1 rounded-md w-[100%] xl:w-[100%]">
          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Aadhaar</label>
              <br />
              <input
                type="text"
                value={governmentIds?.aadhaar_number}
                onChange={(e) =>
                  setGovernmentIds({
                    ...governmentIds,
                    aadhaar_number: e.target.value,
                  })
                }
                placeholder="Enter Aadhaar Number"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable6}
                aria-readonly={!isEditable6 ? "true" : "false"} // Added for accessibility
                style={{
                  boxShadow: isEditable6 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">PAN</label>
              <br />
              <input
                type="text"
                value={governmentIds?.pan_number}
                onChange={(e) =>
                  setGovernmentIds({
                    ...governmentIds,
                    pan_number: e.target.value,
                  })
                }
                placeholder="Enter PAN Number "
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable6} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable6 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Driving License</label>
              <br />
              <input
                type="text"
                value={governmentIds?.driving_license_number}
                onChange={(e) =>
                  setGovernmentIds({
                    ...governmentIds,
                    driving_license_number: e.target.value,
                  })
                }
                placeholder="Enter  License Number"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable6} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable6 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Voter ID</label>
              <br />
              <input
                type="text"
                value={governmentIds?.voter_id_number}
                onChange={(e) =>
                  setGovernmentIds({
                    ...governmentIds,
                    voter_id_number: e.target.value,
                  })
                }
                placeholder="Enter Voter ID "
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable6} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable6 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">UAN</label>
              <br />
              <input
                type="text"
                value={governmentIds?.uan_number}
                onChange={(e) =>
                  setGovernmentIds({
                    ...governmentIds,
                    uan_number: e.target.value,
                  })
                }
                placeholder="Enter UAN Number"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable6} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable6 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex justify-end mt-4 p-3">
            <div className="flex items-center gap-[20px]">
              <button
                disabled={isLoadingGovernmentIds}
                type="button"
                className={
                  "second-btn " +
                  (isLoadingGovernmentIds &&
                    "opacity-50 cursor-not-allowed animate-pulse")
                }
                onClick={() => {
                  handleEditClick2();
                }}
              >
                {isEditable6 ? "Save" : "Edit"}
              </button>
            </div>
          </div>
        </form>

        <h2 className="mt-7 pt-[10px] pb-[0px] font-medium">
          Address Details
        </h2>
        <form className="shadow-md m-auto mt-[10px] p-[12px] xl:p-[24px] border border-1 rounded-md w-[100%] xl:w-[100%]">
          <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Current Address</label>
              <br />
              <textarea
                type="text"
                value={personalDetailsUpdate.current_address}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    current_address: e.target.value,
                  })
                }
                rows="2"
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable7} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable7 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>

            <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
              <label className="text-[14px]">Permanent Address</label>
              <br />
              <textarea
                type="text"
                rows="2"
                value={personalDetailsUpdate.permanent_address}
                onChange={(e) =>
                  setPersonalDetailsUpdate({
                    ...personalDetailsUpdate,
                    permanent_address: e.target.value,
                  })
                }
                className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
                readOnly={!isEditable7} // Input readOnly rahega jab tak isEditable false hai
                style={{
                  boxShadow: isEditable7 ? "0px 0px 5px #dfdcdc" : ""
                }}
              />
            </div>
          </div>

          <div className="flex justify-end mt-4 p-3">
            <div className="flex items-center gap-[20px]">
              <button
                disabled={isLoadingPersonalDetails}
                type="button"
                className={
                  "second-btn " +
                  (isLoadingPersonalDetails &&
                    "opacity-50 cursor-not-allowed animate-pulse")
                }
                onClick={(e) => {
                  handleEditClick3(e);
                }}
              >
                {isEditable7 ? "Save" : "Edit"}
              </button>
            </div>
          </div>
        </form>

      </div>
    </>
  );
};

export default PersonalDetail;
